import { IAnalyticsProvider } from '@/integrations/analytics/types/IAnalyticsProvider';
import { IdentifyTraitsProperties } from '@/integrations/analytics/types/IdentifyTraitsProperties';
import Logger from '/@/modules/core/app/helpers/Logger';

export class AnalyticsManager {
  private providers: IAnalyticsProvider[] = [];
  private initialized: boolean = false;

  registerProvider(provider: IAnalyticsProvider): void {
    this.providers.push(provider);
  }

  init(): void {
    if (this.initialized) {
      return;
    }

    this.providers.forEach((provider: IAnalyticsProvider) => {
      try {
        provider.init();
      } catch (error) {
        Logger.error(`Failed to initialize ${provider.name}: ${error}`);
      }
    });

    this.initialized = true;
  }

  track(eventName: string, properties: Record<string, unknown>): void {
    this.providers.forEach((provider: IAnalyticsProvider) => {
      try {
        provider.track(eventName, properties);
      } catch (error) {
        Logger.error(`[Analytics] ${provider.name} track error: ${error}`);
      }
    });
  }

  page(name: string, properties: Record<string, unknown>, options: Record<string, unknown>): void {
    this.providers.forEach((provider: IAnalyticsProvider) => {
      try {
        provider.page(name, properties, options);
      } catch (error) {
        Logger.error(`${provider.name} page error: ${error}`);
      }
    });
  }

  alias(userId: number): void {
    this.providers.forEach((provider: IAnalyticsProvider) => {
      try {
        provider.alias(userId);
      } catch (error) {
        Logger.error(`${provider.name} alias error: ${error}`);
      }
    });
  }

  identify(userId: number | null, traits: IdentifyTraitsProperties): void {
    this.providers.forEach((provider: IAnalyticsProvider) => {
      try {
        provider.identify(userId, traits);
      } catch (error) {
        Logger.error(`${provider.name} identify error: ${error}`);
      }
    });
  }

  reset(): void {
    this.providers.forEach((provider: IAnalyticsProvider) => {
      try {
        provider.reset();
      } catch (error) {
        Logger.error(`${provider.name} reset error: ${error}`);
      }
    });
  }

  getProviders(): IAnalyticsProvider[] {
    return this.providers;
  }

  getIsInitialized(): boolean {
    return this.initialized;
  }
}

export default new AnalyticsManager();
